import { createSelector } from '@reduxjs/toolkit';
import { helpCenterSelectors } from '@sv-support-sdk/store';

import { routes } from '../../routing';

export const {
  selectCategories,
  selectTopics,
  selectVoted,
  selectLoading,
  grandCategoriesSelector,
  grandCategoryBySlugSelector,
  categoriesByGrandSelector,
  categoryBySlugSelector,
  topicsByCategorySlugSelector,
  topicsToArraySelector,
  topicBySlugSelector,
  isClickedUsefulTopicSelector,
} = helpCenterSelectors;

export const relatedTopicsSelector = createSelector(
  [topicBySlugSelector, topicsToArraySelector],
  (topic, topics) => {
    return (topic?.relations || []).reduce<{ text: string, link: string }[]>((acc, el) => {
      const foundTopic = topics.find(({ id }) => el.id === id);

      if (foundTopic?.categorySlug) {
        acc.push({
          text: el.name,
          link: `${routes.articles}/${foundTopic.categorySlug}/${el.slug}`,
        });
      }

      return acc;
    }, []);
  },
);
